import { PlaygroundSettingsScreen } from "../../features/teacher-settings";

/** FS-11-PH1 놀이터 설정 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/teacher-settings */
export default function PlaygroundSettingsPage() {
  return <PlaygroundSettingsScreen />;
}
